module.exports = __webpack_public_path__ + "static/img/company.1add395.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company.png
// module id = p+lB
// module chunks = 5